export enum UserRole {
  Cashier = 'cashier',
  Waiter = 'waiter',
  Admin = 'admin',
}

export type User = {
  id: number;
  username: string;
  name: string;
  role: UserRole;
  isInternal: boolean;
};
